module.exports = __webpack_public_path__ + "static/img/sm_3.01eb0ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_3.png
// module id = KPZj
// module chunks = 0